module.exports = __webpack_public_path__ + "static/media/e-wonderland-logo.7b4b0abd.png";